'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Makes a GET request.
 * @param  {String}  url     The URL to request
 * @param  {Object}  params  keys/values to be encoded into the URL.
 * @param  {Object}  options Custom axios config
 * @return {Promise}         The response (parsed).
 */


function get(url, params, options) {
  return new Promise(function ($return, $error) {
    return Promise.resolve(requestWrapper(url, 'get', _extends({
      params: params
    }, options))).then($return, $error);
  });
}
/**
 * Makes a POST request.
 * @param  {String}  url     The URL to request
 * @param  {Object}  data    The data to POST.
 * @param  {Object}  options Custom axios config
 * @return {Promise}         The response (parsed).
 */


function post(url, data, options) {
  return new Promise(function ($return, $error) {
    return Promise.resolve(requestWrapper(url, 'post', _extends({
      data: data
    }, options))).then($return, $error);
  });
}
/**
 * Makes a PUT request.
 * @param  {String}  url  The URL to request
 * @param  {Object}  data The data to PUT.
 * @return {Promise}      The response (parsed).
 */


function put(url, data) {
  return new Promise(function ($return, $error) {
    return Promise.resolve(requestWrapper(url, 'put', {
      data: data
    })).then($return, $error);
  });
}
/**
 * Makes a DELETE request.
 * @param  {String}  url  The URL to request.
 * @return {Promise}      The response (parsed).
 */


function del(url) {
  return new Promise(function ($return, $error) {
    return Promise.resolve(requestWrapper(url, 'delete')).then($return, $error);
  });
}
/**
 * Uploads a file
 * @param  {String} url The URL to upload file to
 * @param  {Blob} blob  A window.Blob instance
 * @return {Object} Promise
 */


function uploadFile(url, blob) {
  return new Promise(function (resolve, reject) {
    var handleLoadEnd = function handleLoadEnd(event) {
      var status = event.target.status;

      if (status >= 200 && status < 300) {
        resolve(event);
      } else {
        reject(event);
      }
    };

    var formData = new FormData();
    formData.append('file', blob);
    var xhr = new XMLHttpRequest();
    xhr.addEventListener('loadend', handleLoadEnd);
    xhr.open('POST', url, true);
    xhr.send(formData);
  });
}
/**
 * An HTTP request wrapper that makes a request,
 * parses output, and throws errors for non-2xx responses.
 * Works both on the browser and in node.
 * @param  {String}  url     The URL to request.
 * @param  {String}  method  GET, POST, etc.
 * @param  {Object}  options options.
 * @return {Promise}        The response (parsed).
 */


function requestWrapper(url, method) {
  var $args = arguments;
  return new Promise(function ($return, $error) {
    var options, axiosConfig, response;
    options = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
    options = _extends({}, options, {
      headers: _extends({
        Accept: 'application/json'
      }, options.headers)
    });
    axiosConfig = _extends({}, options, {
      url: url,
      method: method
    });
    return Promise.resolve((0, _axios2.default)(axiosConfig)).then(function ($await_5) {
      try {
        response = $await_5;

        if (response.data === '') {
          return $return(null);
        } else {
          return $return(response.data);
        }

        return $return();
      } catch ($boundEx) {
        return $error($boundEx);
      }
    }, $error);
  });
}

exports.default = {
  get: get,
  post: post,
  put: put,
  delete: del,
  uploadFile: uploadFile
};